class Parallax {
	constructor() {
		this.insides = [];
		this.build();
		resizeCallbacks.push(this);
	}

	build() {
		if (!mobileCheck.isMobile) {
			document.addEventListener('lazyloaded', function (e) {
				const elem = e.target;
				if (elem.dataset.parallaxX) {
					this.parallaxXY(elem, elem.dataset.parallaxX || 50, undefined);
				} else if (elem.dataset.parallaxY) {
					this.parallaxXY(elem, undefined, elem.dataset.parallaxY || 50);
				} else if (elem.dataset.parallaxInside) {
					elem.id = "randomId" + Math.floor(Math.random() * Math.floor(10000000));
					this.inside(elem);
				} else if (elem.dataset.parallaxScale) {
					this.scale(elem);
				}
			}.bind(this));

			document.querySelectorAll('[data-parallax-x]').forEach(function (elem) {
				if (elem.nodeName.toLowerCase() !== 'img') {
					this.parallaxXY(elem, elem.dataset.parallaxX || 50, undefined);
				}
			}.bind(this));

			document.querySelectorAll('[data-parallax-y]').forEach(function (elem) {
				if (elem.nodeName.toLowerCase() !== 'img') {
					this.parallaxXY(elem, undefined, elem.dataset.parallaxY || 50);
				}
			}.bind(this));
		}
	}

	scale(elem) {
		elem.parentNode.parentNode.style.height = elem.clientHeight + 'px';
		elem.parentNode.parentNode.style.width = elem.clientWidth + 'px';
		elem.parentNode.parentNode.style.overflow = 'hidden';
		gsap.to(elem, {
			scale: elem.dataset.parallaxScale,
			ease: 'none',
			scrollTrigger: {
				trigger: elem,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 1
			}
		});
	}

	parallaxXY(elem, x, y) {
		const start = elem.dataset.parallaxStart || 'top bottom';
		const end = elem.dataset.parallaxEnd || 'bottom top';
		const config = {
			ease: 'none',
			scrollTrigger: {
				trigger: elem,
				start: start,
				end: end,
				scrub: 1
			}
		};
		if (x) {
			config.x = x;
		}
		if (y) {
			config.y = y;
		}
		gsap.to(elem, config);
	}

	inside(elem) {
		const parent = $(elem).closest('[data-parallax-container]')[0];
		const ratio = elem.dataset.parallaxInside || 25;
		parent.style.width = elem.clientWidth + 'px';
		parent.style.height = elem.clientHeight + 'px';
		elem.style.height = elem.clientHeight * (ratio / 100 + 1) + 'px';
		elem.style.transform = 'translateY(-' + ratio + '%)';
		this.insides[elem.id] = gsap.to(elem, {
			y: '0',
			ease: 'none',
			scrollTrigger: {
				trigger: elem,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 1
			}
		});
	}

	resize() {
		for (const id in this.insides) {
			this.insides[id].scrollTrigger.kill();
			const elem = document.querySelector('#' + id);
			elem.style.height = null;
			elem.style.width = null;
			let parent = elem.parentNode.parentNode;
			parent.style.width = null;
			parent.style.height = null;
			this.inside(elem);
		}
	}
}
